const Header = () => {
  return (
    <></>
    // <header className="bg-blue-500 text-white p-4 text-center font-bold text-xl">
    //   <p className="text-center">Regulify Application</p>
    // </header>
  );
};

export default Header;
